import React from "react";

const defaultAnticipatedFinancialEffectsData = [
  {
    categoryAFE: "Financial position",
    currentFinancialEffectsAFE: "",
    anticipatedShortAFE: "",
    anticipatedMediumAFE: "",
    anticipatedLongAFE: "",
  },
  {
    categoryAFE: "Financial performance",
    currentFinancialEffectsAFE: "",
    anticipatedShortAFE: "",
    anticipatedMediumAFE: "",
    anticipatedLongAFE: "",
  },
  {
    categoryAFE: "Cash flows",
    currentFinancialEffectsAFE: "",
    anticipatedShortAFE: "",
    anticipatedMediumAFE: "",
    anticipatedLongAFE: "",
  },
];

const AnticipatedFinancialEffectsTable = ({
  anticipatedFinancialEffectsData,
  setAnticipatedFinancialEffectsData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...anticipatedFinancialEffectsData];
    updated[index][field] = value;
    setAnticipatedFinancialEffectsData(updated);
  };

  // styles (same look as your previous tables) — no per-cell borders here
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const categoryCell = {
    ...cell,
    backgroundColor: "#d3c9ce",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const textAreaStyle = { ...inputStyle, minHeight: 70, resize: "vertical" };

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      {/* Outer frame + perfect corners + inner grid */}
      <style>{`
        .afeTableFrame{
          border: 1px solid #000;
          border-radius: 12px;
          overflow: hidden;
        }
        .afeTable{
          width: 100%;
          border-collapse: collapse;
        }
        .afeTable th,
        .afeTable td{
          border: 1px solid #000; /* inner grid lines */
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .afeTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide the outer edges; frame draws outside border */
        .afeTable thead tr:first-child th{ border-top: 0; }
        .afeTable tr th:first-child,
        .afeTable tr td:first-child{ border-left: 0; }
        .afeTable tr th:last-child,
        .afeTable tr td:last-child{ border-right: 0; }
        .afeTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <div className="afeTableFrame">
        <table className="afeTable">
          <thead>
            <tr>
              <th style={{ ...header }} rowSpan={2}>
                Category
              </th>
              <th style={{ ...header }} rowSpan={2}>
                Current
                <br />
                financial
                <br />
                effects
              </th>
              <th style={{ ...header }} colSpan={3}>
                Anticipated financial effects
              </th>
            </tr>
            <tr>
              <th style={header}>Short term</th>
              <th style={header}>Medium term</th>
              <th style={header}>Long term</th>
            </tr>
          </thead>
          <tbody>
            {anticipatedFinancialEffectsData.map((row, index) => (
              <tr key={index}>
                {/* Category column with header color */}
                <td style={categoryCell}>{row.categoryAFE}</td>

                {/* Current financial effects */}
                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.currentFinancialEffectsAFE}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "currentFinancialEffectsAFE",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                {/* Anticipated — Short / Medium / Long */}
                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.anticipatedShortAFE}
                    onChange={(e) =>
                      handleChange(index, "anticipatedShortAFE", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>
                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.anticipatedMediumAFE}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "anticipatedMediumAFE",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>
                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.anticipatedLongAFE}
                    onChange={(e) =>
                      handleChange(index, "anticipatedLongAFE", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnticipatedFinancialEffectsTable;
